import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAuth } from '@/middlewares/auth/auth-context'
import { hasInvoiceAddress } from '@/utils/invoiceAddress'
import TranslationNS from '@/utils/Constants/TranslationNS'

import './ModalStripeInformations.css'

const errors = {
    missingStripe: {
        message: 'You still have to connect your Stripe account',
        linkText: 'Connect Stripe',
        linkUrl: import.meta.env.VITE_STRIPE_INTEGRATION,
    },
    missingGeneralSettings: {
        message: 'You still have to complete your organisations settings',
        linkText: 'Complete my informations',
        linkUrl: '/my-account',
    },
}

const getError = (user) => {
    if (user.type !== 'orga') {
        return
    }

    const settings = user.organisation_settings

    if (!settings.stripe?.account_completed) {
        return errors.missingStripe
    } else if (!user.organisation || !settings.phone_number || !hasInvoiceAddress(settings.invoice_address)) {
        return errors.missingGeneralSettings
    }

    return
}

/** Floating reminder for organizers whose Stripe account or organisation settings are incomplete. */
const ModaLStripeInformations = () => {
    const { t } = useTranslation(TranslationNS.STRIPE)
    const authContext = useAuth()

    const [error, setError] = useState()

    useEffect(() => {
        setError(getError(authContext.user))
    }, [authContext.user])

    if (!error) {
        return <></>
    }
    return (
        <aside className="stripe-note" role="status" aria-labelledby="stripe-note-ttl">
            <p className="stripe-note-ttl" id="stripe-note-ttl">
                {t('Organizer account to complete')}
            </p>
            <p className="stripe-note-txt">{t(error.message)}</p>
            <a href={error.linkUrl} className="stripe-note-link">
                {t(error.linkText)}
            </a>
        </aside>
    )
}

export default ModaLStripeInformations
